module.exports = __webpack_public_path__ + "static/media/gb-wls.8b438f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gb-wls.png
// module id = 1854
// module chunks = 0